module.exports = __webpack_public_path__ + "img/case_06.d0721540.jpg";